import { render, staticRenderFns } from "./DoctorReportLoreal.vue?vue&type=template&id=565cf903&scoped=true"
import script from "./DoctorReportLoreal.vue?vue&type=script&lang=ts"
export * from "./DoctorReportLoreal.vue?vue&type=script&lang=ts"
import style0 from "./DoctorReportLoreal.vue?vue&type=style&index=0&id=565cf903&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565cf903",
  null
  
)

export default component.exports